const EXECUTION_STATUS = {
  QUEUED: 'QUEUED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  TIMED_OUT: 'TIMED_OUT',
  REJECTED: 'REJECTED',
  REMOVED: 'REMOVED',
  CANCELED: 'CANCELED',
};

const LISTENERS = {
  PENDING_JOBS: 'PENDING_JOBS',
  PENDING_JOBS_ACCEPTED: 'PENDING_JOBS_ACCEPTED',
  PENDING_JOBS_REJECTED: 'PENDING_JOBS_REJECTED',
  UPDATE_SIGNAL: 'UPDATE_SIGNAL',
  UPDATE_JOB: 'UPDATE_JOB',
  UPDATE_JOB_ACCEPTED: 'UPDATE_JOB_ACCEPTED',
  UPDATE_JOB_REJECTED: 'UPDATE_JOB_REJECTED',
  JOB_DETAILS: 'JOB_DETAILS',
  JOB_DETAILS_ACCEPTED: 'JOB_DETAILS_ACCEPTED',
  JOB_DETAILS_REJECTED: 'JOB_DETAILS_REJECTED',
}

export { EXECUTION_STATUS, LISTENERS };